import { IUser } from "../types/user";
import { apiCore } from "./apiCore";

export const loadUsers = async (): Promise<IUser[]> => {
  // console.log("API - loadUsers");
  const response = await apiCore<IUser[]>("/user", {
    method: "GET",
  });

  // console.log("loadUsers", response);

  return response.data;
};
